module.exports = __webpack_public_path__ + "static/img/manu.4ae8e024.png";